import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementBalanceEmailTemplate.Delete.IRequest;
type Response = Api.Core.ProviderStatementBalanceEmailTemplate.Delete.IResponse;
type Headers = Api.Core.ProviderStatementBalanceEmailTemplate.Delete.IHeaders;
const url = '/api/Management/ProviderStatementBalanceEmailTemplate/:id';
export default async function providerStatementBalanceEmailTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
